module.exports = __webpack_public_path__ + "static/media/icons-3.c4267e46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/take-care/icons-3.svg
// module id = 1662
// module chunks = 0